export default "__VITE_ASSET__Byp1gfLq__"